<div class="regras-tomador">

  <app-regras-toolbar
    [busca]="busca"
    [filtroAtivo]="filtroAtivo"
    [situacaoOptions]="filtroSituacaoOptions"
    [carregando]="loading"
    placeholder="CNPJ ou razão social"
    rotuloNovo="Novo tomador"
    (buscar)="filtrar($event)"
    (filtrarSituacao)="onFiltroSituacao($event)"
    (atualizar)="carregar()"
    (novo)="abrirNova()">
  </app-regras-toolbar>

  <app-regras-skeleton
    *ngIf="loading && !itens.length"
    rotulo="Carregando os tomadores habilitados">
  </app-regras-skeleton>

  <po-table
    *ngIf="!loading || itens.length"
    [p-columns]="columns"
    [p-items]="itens"
    [p-actions]="tableActions"
    [p-loading]="loading || loadingMore"
    [p-sort]="true"
    [p-striped]="true"
    [p-height]="tableHeight"
    [p-show-more-disabled]="!hasMore"
    (p-show-more)="carregarMais()">
  </po-table>

</div>

<po-modal
  #formModal
  [p-title]="modalTitle"
  p-size="md"
  [p-primary-action]="modalPrimaryAction"
  [p-secondary-action]="modalSecondaryAction">

  <div class="regras-form" [formGroup]="formGroup">

    <div class="po-row">
      <small class="po-md-12 po-font-text-small">
        Tomadores listados aqui podem ter o CT-e aprovado <b>sem processo</b>,
        com o tipo de operação e a natureza informados abaixo.
      </small>
    </div>

    <div class="po-row">
      <po-input
        class="po-md-6"
        p-label="CNPJ do tomador"
        p-placeholder="00.000.000/0000-00"
        [p-mask]="cnpjMask"
        [p-pattern]="cnpjPattern"
        p-error-pattern="CNPJ inválido."
        formControlName="cnpj"
        p-required>
      </po-input>

      <po-input
        class="po-md-6"
        p-label="Razão social"
        formControlName="nome"
        [p-maxlength]="60"
        p-required>
      </po-input>
    </div>

    <div class="po-row" *ngIf="editing">
      <small class="po-md-12 po-font-text-small">
        O CNPJ é a chave do cadastro e não pode ser alterado. Para trocá-lo,
        inative este registro e inclua outro.
      </small>
    </div>

    <div class="po-row">
      <po-combo
        class="po-md-4"
        p-label="Tipo de operação (TES)"
        p-filter-service="portalnf/regras/lookup/tes"
        p-field-label="label"
        p-field-value="value"
        [p-sort]="true"
        name="tes"
        formControlName="tes"
        [p-required]="true"
        [p-infinite-scroll]="true">
      </po-combo>

      <po-combo
        class="po-md-4"
        p-label="Natureza financeira"
        p-filter-service="portalnf/regras/lookup/natureza"
        p-field-label="label"
        p-field-value="value"
        [p-sort]="true"
        name="natureza"
        formControlName="natureza"
        [p-required]="true"
        [p-infinite-scroll]="true">
      </po-combo>

      <po-select
        class="po-md-4"
        p-label="Situação"
        [p-options]="situacaoOptions"
        formControlName="ativo"
        p-required>
      </po-select>
    </div>

    <div class="po-row" *ngIf="editing?.usrAlt">
      <small class="po-md-12 po-font-text-small regras-auditoria">
        Última alteração por <b>{{ editing?.usrAltNome || editing?.usrAlt }}</b>
        em {{ formatarData(editing?.dtAlt) }} às {{ editing?.hrAlt }}.
      </small>
    </div>

  </div>

</po-modal>
